import { Controller } from "@hotwired/stimulus";

const INTERACTIVE = "a, button, input, label, [data-prevent-card-nav]";

export default class extends Controller {
  static classes = ["highlight"];

  connect() {
    this._onClick = (event) => this._navigate(event);
    this._onOver = (event) => this._hover(event, "valuersCards:hoverValuerEnter");
    this._onOut = (event) => this._hover(event, "valuersCards:hoverValuerLeave");
    this.element.addEventListener("click", this._onClick);
    this.element.addEventListener("mouseover", this._onOver);
    this.element.addEventListener("mouseout", this._onOut);

    this._onSelect = (event) => this._select(event.detail);
    this._onPinEnter = (event) => this._setHighlight(event.detail, true);
    this._onPinLeave = (event) => this._setHighlight(event.detail, false);
    window.addEventListener("map:selectValuer", this._onSelect);
    window.addEventListener("map:hoverValuerEnter", this._onPinEnter);
    window.addEventListener("map:hoverValuerLeave", this._onPinLeave);
  }

  disconnect() {
    this.element.removeEventListener("click", this._onClick);
    this.element.removeEventListener("mouseover", this._onOver);
    this.element.removeEventListener("mouseout", this._onOut);
    window.removeEventListener("map:selectValuer", this._onSelect);
    window.removeEventListener("map:hoverValuerEnter", this._onPinEnter);
    window.removeEventListener("map:hoverValuerLeave", this._onPinLeave);
  }

  _navigate(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.target.closest(INTERACTIVE)) return;
    const card = event.target.closest("[data-card]");
    if (!card) return;
    this._emit("valuersCards:focusValuer", { id: card.dataset.id, kind: "valuers" });
  }

  _hover(event, name) {
    const card = event.target.closest("[data-card]");
    if (!card || card.contains(event.relatedTarget)) return;
    this._emit(name, { id: card.dataset.id, kind: "valuers" });
  }

  _select(marker) {
    const card = this._card(marker);
    if (!card) return;
    this._cards().forEach((el) => el.classList.remove(...this.highlightClasses));
    card.classList.add(...this.highlightClasses);
    this._selectedId = String(marker.id);
    card.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  _setHighlight(marker, on) {
    const card = this._card(marker);
    if (!card) return;
    if (!on && this._selectedId === String(marker.id)) return;
    this.highlightClasses.forEach((c) => card.classList.toggle(c, on));
    if (on) card.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  _card(marker) {
    if (!marker || marker.id == null) return null;
    return this.element.querySelector(`[data-card][data-id="${CSS.escape(String(marker.id))}"]`);
  }

  _cards() {
    return Array.from(this.element.querySelectorAll("[data-card]"));
  }

  _emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  }
}
